
  import { defineComponent } from 'vue';

  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';

  export default defineComponent({
    name: 'NotFoundPage',
    components: { ButtonComponent },
    methods: {
      goToHome() {
        this.$router.push({ name: 'home' });
      },
    },
  });
